import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from "react-redux"
import { hasPermission } from "../../store/apiWrapper";
import { marketingListActions, unicornAttribute } from "../../store/marketingListStore"
import { Translate, withLocalize } from 'react-localize-redux';
import BbCheckbox from '../styling/bbCheckbox';
import CrossIcon from '../../img/icons/Cross';
import { isNullOrUndefined } from '../../store/storeFunctions';

class MarketingListSectionsManager extends React.Component {
    render() {
        return (
            <article className="panel">
                <div className="panel-heading">
                    <div className='panel-heading-title'>
                        <div style={{ marginRight: 'auto', marginTop: 'auto', marginBottom: 'auto' }}><Translate id="Marketing.Add.Remove.Criteria" /></div>
                        <CrossIcon className='icon-centered' onClick={this.props.closePanel} style={{ marginLeft: '.5em' }} />
                    </div>
                </div>
                <div className="panel-block bb-chk-grp-all">
                    <BbCheckbox
                            id="params-popup-all"
                            label={this.props.translate("Multiselect.CheckAll")}
                            value={this.isAllChecked()}
                            onChange={(value) => { this.onCheckAll(value) }}
                        />
                    {Object.entries(this.props.marketingList.sections).sort((a, b) => a[1].order - b[1].order).map((s) => {
                        let sectionName = s[0];
                        if (sectionName === "xlsFileContent") return null;
                        else {
                            let role = s[1].role;
                            if (role !== null && !hasPermission(null, role)) return null;
                            let marketAttr = s[1].marketAttribute;
                            if (!isNullOrUndefined(marketAttr) && marketAttr !== unicornAttribute()) return null;
                            return (
                                <BbCheckbox key={sectionName} label={this.props.translate(`Search.MarketingSection.${sectionName.charAt(0).toUpperCase() + sectionName.slice(1)}`)} value={s[1].checked} id={sectionName}
                                    onChange={(value) => { this.onCheckSection(sectionName, value) }} />
                            )
                        }
                    })}
                </div>
            </article>
        );
    }

    hasPermissionForCountry = (section) => {
        let role = section[1].role;
        if (role !== null && !hasPermission(null, role)) return false;
        let marketAttr = section[1].marketAttribute;
        if (!isNullOrUndefined(marketAttr) && marketAttr !== unicornAttribute()) return false;
        return true;
    }

    onCheckSection = (name, value) => {
        this.props.checkSection(name, value);
    }

    onCheckAll = (value) => {
        Object.entries(this.props.marketingList.sections).filter(x => this.hasPermissionForCountry(x)).map(x => x[0] !== "xlsFileContent" && this.props.checkSection(x[0], value));
    }

    isAllChecked = () => {
        let checkedCount = Object.entries(this.props.marketingList.sections).filter(x => x[1].checked && x[0] !== "xlsFileContent").length;
        let allCount = Object.entries(this.props.marketingList.sections).filter(x => x[0] !== "xlsFileContent").length;
        if (checkedCount === 0) { return false };
        if (checkedCount === allCount) { return true };
        return null;
    }   
}

export default withLocalize(connect(
    state => { return { marketingList: state.marketingList } },
    dispatch => bindActionCreators(marketingListActions, dispatch)
)(MarketingListSectionsManager));